module.exports = __webpack_public_path__ + "static/img/p4.0dfc142.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/p4.png
// module id = /iN5
// module chunks = 0